import {
  ProxyRegisterSelectsRequest,
  ProxySelectRegistrationFormEntity,
  ProxySelectRegistrationItemEntity,
  RoomSelectMasterEntity,
} from 'src/types'

export const ProxySelectRegistrationTranslator = {
  toFormEntity: (entity: RoomSelectMasterEntity): ProxySelectRegistrationItemEntity => {
    return {
      id: entity.id,
      selectMasterId: entity.selectMasterId,
      optionIds: [],
    }
  },

  toRequests: (formEntity: ProxySelectRegistrationFormEntity): ProxyRegisterSelectsRequest[] => {
    return formEntity.items.map(item => {
      return {
        id: Number(item.id),
        selectOptionIds: item.optionIds,
      }
    })
  },
} as const
